export default __webpack_public_path__ + "b737485ca4a5c87d9b8790d9e87cbe20.png";